"use strict";
import darkStyles from "./src/theme-dark.css.js";
import { Theme } from "./src/Theme.dev.js";
import "./core.dev.js";
Theme.registerThemeFragment("dark", "color", darkStyles);
//# sourceMappingURL=theme-dark.dev.js.map
